import React, { Component } from "react";
import { connect } from 'react-redux';
import { TablePagination } from "../../../../common/details-table/table-pagination.component";
import { invoiceHistoryActions } from "../../../../../store/external/invoice/invoice/invoice-history.reducer";
class InvoiceHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
        }
    }

    componentDidMount() {
        console.log('history page', this.props);
        const {getInvoiceHistory, invoiceDetailsId} = this.props;
        getInvoiceHistory(invoiceDetailsId);

    }

    onColumnSearch = () => {
        const { getInvoiceHistory, invoiceDetailsId } = this.props;
        getInvoiceHistory(invoiceDetailsId, 0);
    }

    paginationAction = (pageIndex) => {
        const { getInvoiceHistory, invoiceDetailsId } = this.props;
        getInvoiceHistory(invoiceDetailsId, pageIndex);
    }

    resizePage = (value) => {
        const { getInvoiceHistory, invoiceDetailsId, resizeInvoiceHistoryLogs } = this.props;
        resizeInvoiceHistoryLogs(value);
        getInvoiceHistory(invoiceDetailsId);
    }

    componentWillUnmount() {
        this.props.resetInvoiceHistory();
    }
    formatNumericValues(data) {
        return data.map(item => {
            if (!isNaN(item.NewValue) && !isNaN(item.OldValue) && (item.Object !== "Invoice Status ID" || item.Object.includes("Date"))) {

                let newVal = item.NewValue !== '' ? parseFloat(item.NewValue) : "";
                let oldVal = item.OldValue !== '' ? parseFloat(item.OldValue) : "";

                if (item.Object === "Billing Account Number" || item.Object === "EDI Number" || item.Object === "Check Num") {
                    newVal = newVal !== '' ? newVal.toString() : "";
                    oldVal = oldVal !== '' ? oldVal.toString() : "";
                } else {
                    newVal = newVal !== '' ? newVal.toFixed(2) : "";
                    oldVal = oldVal !== '' ? oldVal.toFixed(2) : "";
                }

                return { ...item, "NewValue": newVal, "OldValue": oldVal };
            }
            return { ...item };
        });
    }
    render() {
        const {invoiceHistory, setInvoiceHistoryColSearchStr} = this.props;
        const {Data, Headers, Pagination } = invoiceHistory.invoiceHistoryTable;
        const {isInvoiceHistoryLoading } = invoiceHistory;

        return (
            <>
                <TablePagination
                        key="table-pagination-key"
                        columns={Headers}
                        pageList={this.formatNumericValues(Data?.Items)}
                        pages={Pagination}
                        paginationAction={this.paginationAction}
                        onColumnSearch={() => { this.onColumnSearch() }}
                        onColumnSearchChange={setInvoiceHistoryColSearchStr}
                        isColSearchShow={this.props.isColSearchShow}
                        resizePage={this.resizePage}
                        totalPage={Pagination?.TotalEntries}
                        isNotSortable={true}
                        isLoading={isInvoiceHistoryLoading}
                        hideStatusIcon={true}
                    />
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        invoiceHistory: state.invoiceHistory
    }
} 

const dispatchStateToProps = (dispatch) => {
    return {
        getInvoiceHistory: (invoiceId, pageIndex) => dispatch(invoiceHistoryActions.getInvoiceHistory(invoiceId, pageIndex)),
        resetInvoiceHistory: () => dispatch(invoiceHistoryActions.resetInvoiceHistory()),
        setInvoiceHistoryColSearchStr: (event, key) => dispatch(invoiceHistoryActions.setInvoiceHistoryColSearchStr(event, key)),
        resizeInvoiceHistoryLogs: (value) => dispatch(invoiceHistoryActions.resizeInvoiceHistoryLogs(value))
    }
}
export default connect(mapStateToProps, dispatchStateToProps )(InvoiceHistory);